<template>
  <v-row>
    <v-col cols="12">
      <Filtro />
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-col cols="4">
          <RelatorioComissao />
        </v-col>
        <v-col cols="8">
          <v-card elevation="0">
            <v-row>
              <v-col cols="6" class="pt-0">
                <ChartPie />
              </v-col>
              <v-col cols="6" class="pt-0">
                <ChartSpeedometer />
              </v-col>
              <v-col cols="12" class="pb-0">
                <ChartMetaRealizado />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {
    Filtro: () => import("./components/Filtro"),
    RelatorioComissao: () => import("./components/RelatorioComissao"),
    ChartPie: () => import("./components/ChartPie"),
    ChartSpeedometer: () => import("./components/ChartSpeedometer"),
    ChartMetaRealizado: () => import("./components/ChartMetaRealizado")
  }
};
</script>

<style>
</style>